import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  width: 100%;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-top: 1px solid #eee;
  margin-top: 4rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
`;

const Copyright = styled.p`
  margin: 0.5rem 0;
`;

const getCurrentYear = () => new Date().getFullYear();

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <p>Protection des données personnelles - Tous droits réservés</p>
        <Copyright>
          © {getCurrentYear()} - Développé par Isaac Naranjo
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
